import classNames from 'classnames';
import React from 'react';
import { ThemeNames, useThemeContext } from '../../libs/theme-provider';
import darkIcon from './images/darkIcon.svg';
import lightIcon from './images/lightIcon.svg';
import './style.scss';

export default function DarkModeSwitcher() {
  const { isCurrentThemeDark, changeTheme } = useThemeContext();

  return (
    <label
      className={classNames('DarkModeSwitcher', { DarkModeSwitcher__active: isCurrentThemeDark })}
      id="DarkModeSwitcher"
    >
      <input
        type="checkbox"
        checked={isCurrentThemeDark}
        onChange={() =>
          isCurrentThemeDark ? changeTheme(ThemeNames.default) : changeTheme(ThemeNames.dark)
        }
      />
      <span className="DarkModeSwitcher__slider">
        <img src={isCurrentThemeDark ? darkIcon : lightIcon} alt="" />
      </span>
    </label>
  );
}
